import { useSelector } from 'react-redux';

import { useSessionManager } from '@/hooks/useSessionManager';

import SessionTimeoutModal from './SessionTimeoutModal';

import type { RootState } from '@/app/store/store';

/**
 * SessionManagerBootstrap
 *
 * Mounts the session-management hook at app-shell level so it persists across
 * route changes. Renders the idle-timeout warning modal when appropriate.
 *
 * Must be placed inside BrowserRouter (for useNavigate) and Redux Provider.
 * Returns null when the user is not authenticated — zero cost on public pages.
 */
function SessionManagerBootstrap() {
    const isAuthenticated = useSelector((state: RootState) => state.authStore.isAuthenticated);

    const { showWarning, secondsLeft, handleContinue, handleLogout } = useSessionManager();

    if (!isAuthenticated) return null;

    return (
        <SessionTimeoutModal
            open={showWarning}
            secondsLeft={secondsLeft}
            onContinue={handleContinue}
            onLogout={handleLogout}
        />
    );
}

export default SessionManagerBootstrap;
